import * as React from 'react';

import { useAuth } from '@/auth/auth-context';
import { useNotificationRealtime } from '@/realtime/use-notification-realtime';

// =============================================================================
// supplier-realtime-notifications.tsx — Montage de l'abonnement temps réel (R15-COM-06).
// =============================================================================
// Monte l'abonnement socket + le repli polling UNIQUEMENT pour une session FOURNISSEUR (les notifications
// sont supplier-scopées, @SupplierRoute). Ne rend RIEN. Monté dans le point d'entrée SPA (main.tsx), sous
// les providers (QueryClient + BannerProvider + Auth). Hors périmètre des tests de shell (aucun socket en
// jsdom) ; le comportement d'invalidation/bandeau est couvert par un test unitaire dédié (fake connect).

export function SupplierRealtimeNotifications(): React.JSX.Element | null {
  const auth = useAuth();
  const enabled = auth.role === 'supplier';
  // `enabled` gouverne l'activation : hors session fournisseur, aucun socket ni polling n'est monté.
  useNotificationRealtime({ enabled });
  return null;
}
